export default __webpack_public_path__ + "static/media/ozoneiq-color.9ec767a7.png";